import { useCallback } from 'react'
import { useParams } from 'react-router-dom'

export function useLocalePath() {
  const { lang } = useParams<{ lang: string }>()
  return useCallback((path: string) => `/${lang || 'en'}${path}`, [lang])
}
